import { FormMultiselect } from '@shared/ui';
import { type MultiSelectProps } from '@mantine/core';
import { useGetSkill } from '@entities/skill';

//
//

interface FormGuideSkillProps extends MultiSelectProps {
  title?: string;
  description?: string;
  placeholder?: string;
}

export const FormGuideSkill = ({
  title = 'Ключевые навыки',
  description = 'Выберите все необходимые ключевые навыки сотрудника',
  placeholder = 'Выберите',
  ...props
}: FormGuideSkillProps) => {
  const { data, isLoading } = useGetSkill();

  return (
    <FormMultiselect
      {...props}
      title={title}
      description={description}
      placeholder={placeholder}
      isLoading={isLoading}
      data={data?.map(item => ({
        label: item.name,
        value: item.id.toString(),
      }))}
      searchable
    />
  );
};
